import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import card3 from "../../Assets/Images/AIImg.png";
import card2 from "../../Assets/Images/user2.png";
import Flag from "../../Assets/Images/pencil.png";
import { GoDotFill } from "react-icons/go";
import { Link } from "react-router-dom";

function DiagnosticSuggestionsPending() { 

  return (
    <div className="container-fluid">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-9 main-dash-left">
          <section className="back-dashboard-sec comn-dashboard-page">
            <div className="cstm_bredcrumb_outer">
              <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/diagnostic-suggestions" }}>Diagnostic Suggestions</Breadcrumb.Item>
                <Breadcrumb.Item active >View Details</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div className="notifi-list d-flex">
              <h6 className="comm_page_heading mb-0">Diagnostic Suggestions Details</h6>
            </div>
            <Row className="row-gap-5">
              <Col lg={8}>
                <h5 className="comm_inner_sub_heading"> Conversation Details </h5>
                <div className="ai_chat_box_left">
                  <div className="chat-main">
                    <div className="all-chat-main">
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card3} alt="" className="img-fluid" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="chat-box">
                                <p className="chat_text first_user_txt">
                                  <strong>Hello Roger, </strong>I am here to
                                  help you.
                                </p>
                                <span className="cs_chat_time first">
                                  <img src={Flag} alt="" className="img-fluid" />
                                  7:51 PM
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card3} alt="" className="img-fluid" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="chat-box">
                                <p className="chat_text second_user_txt">
                                  Please provide me your details before
                                  proceeding.
                                </p>
                                <span className="cs_chat_time second">
                                  <img src={Flag} alt="" className="img-fluid" />
                                  7:51 PM
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card3} alt="" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="inner_chat_form_box">
                                <div className="chat-box">
                                  <p className="chat_text second_user_txt"> Please provide me your details before proceeding.</p>
                                  <span className="cs_chat_time second">
                                    <img src={Flag} alt="" className="img-fluid" />
                                    7:51 PM</span>
                                </div>
                                <div className="chat_inn_box">
                                  <div className="img-chat-date d-flex">
                                    <div className="profile-chat-img">
                                      <img src={card2} alt="" />
                                    </div>
                                    <div className="d-flex gap-4 flex-column w-100 ">
                                      <Form.Group className='comn-class-inputs'>
                                        <Form.Control type="text" as="textarea" placeholder="Enter Your Notes Here"
                                          style={{ height: "90px", width: "100%", resize: "none" }}
                                        />
                                      </Form.Group>
                                      <Form.Group className='comn-class-inputs'>
                                        <Form.Label>Reason for change</Form.Label>
                                        <Form.Control type="text" as="textarea" placeholder="Enter Your Reason Here"
                                          style={{ height: "90px", width: "100%", resize: "none" }}
                                        />
                                      </Form.Group>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex inner_chat_btn_grp">
                                  <button className="discard_btn">
                                    Discard Changes
                                  </button>
                                  <button className="main-btn chat_inner_btn">
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box second_user_txt-flex">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card2} alt="" className="img-fluid" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="chat-box">
                                <p className="chat_text second_user_txt">
                                  Keeping this in mind, Grameenphone always
                                  brings future-proof technology in order to
                                  facilitate your progress.
                                </p>
                                <span className="cs_chat_time second">
                                  <img src={Flag} alt="" className="img-fluid" />
                                  7:51 PM
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card3} alt="" className="img-fluid" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="chat-box">
                                <p className="chat_text second_user_txt">
                                  Please provide me your details before
                                  proceeding.
                                </p>
                                <span className="cs_chat_time second">
                                  <img src={Flag} alt="" className="img-fluid" />
                                  7:51 PM
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card3} alt="" className="img-fluid" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="chat-box">
                                <p className="chat_text second_user_txt">
                                  Please provide me your details before
                                  proceeding.
                                </p>
                                <span className="cs_chat_time second">
                                  <img src={Flag} alt="" className="img-fluid" />
                                  7:51 PM
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column chat_box">
                        <div className="chat_inn_box">
                          <div className="img-chat-date d-flex">
                            <div className="profile-chat-img">
                              <img src={card3} alt="" />
                            </div>
                            <div className="chat_box_outer">
                              <div className="chat-box">
                                <p className="chat_text second_user_txt">
                                  Please provide me your details before
                                  proceeding.
                                </p>
                                <span className="cs_chat_time second">
                                  <img src={Flag} alt="" className="img-fluid" />
                                  7:51 PM
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <h5 className="comm_inner_sub_heading"> Patient Details: </h5>
                <div className="patient-detail-outer">
                  <div className="patient-anme-view">
                    <h5>patient ID:</h5>
                    <p>#12352</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>patient name:</h5>
                    <p>ashlyn mango</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Phone Number:</h5>
                    <p>326547894</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Email:</h5>
                    <p>LindseyPhilips@gmail.com</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>date of consultation:</h5>
                    <p>25 Jan 2025</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>age:</h5>
                    <p>24</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Gender:</h5>
                    <p>Female</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>Condition:</h5>
                    <p>chest pain</p>
                  </div>
                  <div className="patient-anme-view">
                    <h5>status:</h5>
                    <div className="pending-status">
                      <GoDotFill />
                      Pending
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="d-flex comm_same_wid_btns">
              <button className="main-btn chat_bottom_btn mt-0" >
                Apporve
              </button>
              <button className="main-outline-btn chat_bottom_btn mt-0" >
                Discard
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default DiagnosticSuggestionsPending;